import { PaginationControls } from './PaginationControls';
import { PaginationSizeSelector } from './PaginationSizeSelector';
import { PaginationInfo } from './PaginationInfo';
import type { UsePaginationReturn } from '@/shared/types/pagination';

export interface PaginationProps extends UsePaginationReturn {
  pageSizeOptions?: number[];
}

export function Pagination({ pageSizeOptions, ...pagination }: PaginationProps) {
  return (
    <div className="flex items-center min-h-[52px] px-4">
      {/* Left spacer — balances Zone B+C so Zone A stays truly centered */}
      <div className="flex-1" />

      {/* Zone A — navigation controls, centered */}
      <PaginationControls
        pageIndex={pagination.pageIndex}
        visiblePages={pagination.visiblePages}
        canPrevious={pagination.canPrevious}
        canNext={pagination.canNext}
        goToPage={pagination.goToPage}
        next={pagination.next}
        previous={pagination.previous}
        first={pagination.first}
        last={pagination.last}
      />

      {/* Zone B + C — right edge */}
      <div className="flex items-center gap-2 flex-1 justify-end">
        <PaginationSizeSelector
          pageSize={pagination.pageSize}
          pageSizeOptions={pageSizeOptions}
          onChangePageSize={pagination.changePageSize}
        />
        <PaginationInfo
          pageIndex={pagination.pageIndex}
          pageSize={pagination.pageSize}
          totalItems={pagination.totalItems}
        />
      </div>
    </div>
  );
}
